var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Updates & news'),expression:"'Updates & news'"}],staticClass:"inbox",on:{"click":_vm.onClick}},[_c('div',{staticClass:"inbox-icon"},[(_vm.unread)?_c('div',{staticClass:"inbox-count"}):_vm._e(),_c('i',{staticClass:"fa-solid fa-megaphone"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }